export default "__VITE_ASSET__wzmQpKff__"